module.exports = __webpack_public_path__ + "static/media/botuvera.3e89f617.jpg";